<template>
    <div class="tg-tabbar bg-white" :class="rsTheme">
        <!-- 自动宽度theme==0 -->
        <div v-if="theme==0 || theme==7" class="paddingh20" >
            <div class="scroll-container ">
                <div class="tg-tabbar-item marginr30 paddingv10" v-for="item in data" style="font-size:14px;line-height:28px" data-scp="tabBar.{{$index}}" @click="loadContent(item,$index)" :class="{'active':$index==activeIndex}">
                    <span v-html="item.title"></span>
                </div>
            </div>
        </div>
        <!-- 计算宽度theme!=0 -->
        <div v-else>
            <div class="tg-tabbar-warp clearfix" v-bind:style="{'width':warpWidth}" >
                <div class="tg-tabbar-item float-left pos-r" v-for="item in data" :class="{'active':$index==activeIndex}" v-bind:style="{width:itemWidth}" data-scp="tabBar.{{$index}}" @click="loadContent(item,$index)">
                    <i class="icon icon-{{item.font}}" v-if="item.font"></i>
                    <p v-if="mode==='html'" v-html="item.title" class="tg-tabbar-title"></p>
                    <p v-else v-text="item.title" class="tg-tabbar-title"></p>
                    <p v-text="item.subTitle" class="tg-tabbar-subTitle"></p>
                </div>
            </div>
            <div class="abs-right flex-container paddingh20 marginv10 bg-white borderl tg-tabbar_rightCrow" @click="scrollNext" style="bottom:10px" v-if="theme==4">
                <i class="icon icon-right" style="display: block"></i>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .tg-tabbar.theme_0 .tg-tabbar-item:first-child:after{
        content: none;
    }

    .tg-tabbar.theme_0{
        
    }
    .tg-tabbar.theme_0 .tg-tabbar-item{
        border-bottom:2px solid transparent;
    }
    .tg-tabbar.theme_0 .tg-tabbar-item.active{
        border-bottom:2px solid #FF4C48;
    }
    .tg-tabbar.theme_1{
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom:10px;
        margin-bottom:-10px;
    }
    .tg-tabbar.theme_1::-webkit-scrollbar {
      height: 0px;
    }
    .tg-tabbar.theme_1 .tg-tabbar-warp{
        background-color:white;
    }
    .tg-tabbar.theme_1 .tg-tabbar-item{
        padding:0.133333333rem;
        text-align: center;
        border-right:1px solid #e0e0e0;
    }
    .tg-tabbar.theme_1 .tg-tabbar-item i{
        font-size:20px;
    }
    .tg-tabbar.theme_1 .tg-tabbar-item p{
        font-size:10px;
    }
    .tg-tabbar.theme_1 .tg-tabbar-item.active {
    background-color: #16cc90;
    color: white; }
    .tg-tabbar.theme_1 .tg-tabbar-item.active:before {
    position: absolute;
    display: block;
    content: '';
    width: 10px;
    height: 10px;
    left: 50%;
    margin-left: -5px;
    bottom: -9px;
    border: 5px solid transparent;
    border-top-color: #16cc90;}
    .tg-tabbar.theme_2{
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom:10px;
        margin-bottom:-10px;
        color:#666;
    }
    .tg-tabbar.theme_2::-webkit-scrollbar {
      height: 0px;
    }
    .tg-tabbar.theme_2 .tg-tabbar-warp{
        background-color:white;
    }
    .tg-tabbar.theme_2 .tg-tabbar-item{
        padding:0.2666666666rem;
        text-align: center;
    }
    .tg-tabbar.theme_2 .tg-tabbar-item:first-child:after{
        position: absolute;
        display: block;
        content: '';
        width: 1px;
        height: 20px;
        right: 0;
        top:50%;
        margin-top:-10px;
        background-color: #e0e0e0;
    }
    .tg-tabbar.theme_2 .tg-tabbar-item i{
        font-size:13px;
    }
    .tg-tabbar.theme_2 .tg-tabbar-item p{
        display:inline-block;
        font-size:15px;
    }
    .tg-tabbar.theme_2 .tg-tabbar-item.active {
    color: #ff6565; }
    .tg-tabbar.theme_2 .tg-tabbar-item.active:before {
    position: absolute;
    display: block;
    content: '';
    width: 60%;
    height: 2px;
    left: 50%;
    margin-left: -32%;
    bottom: 0;
    background-color: #ff6565;}
    .tg-tabbar.theme_3{
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom:10px;
        margin-bottom:-10px;
        color:#666;
    }
    .tg-tabbar.theme_3::-webkit-scrollbar {
        height: 0px;
    }
    .tg-tabbar.theme_3 .tg-tabbar-warp{
        background-color:white;
    }
    .tg-tabbar.theme_3 .tg-tabbar-item{
        padding:0.1666666666rem;
        text-align: center;
    }
    .tg-tabbar.theme_3 .tg-tabbar-item:first-child:after{
        position: absolute;
        display: block;
        content: '';
        width: 1px;
        height: 20px;
        right: 0;
        top:50%;
        margin-top:-10px;
        background-color: #e0e0e0;
    }
    .tg-tabbar.theme_3 .tg-tabbar-item i{
        font-size:13px;
    }
    .tg-tabbar.theme_3 .tg-tabbar-item p{
        display:inline-block;
        font-size:13px;
    }
    .tg-tabbar.theme_3 .tg-tabbar-item.active {
        color: #f5253c; }
    .tg-tabbar.theme_3 .tg-tabbar-item.active:before {
        position: absolute;
        display: none;
        content: '';
        width: 90%;
        height: 2px;
        left: 50%;
        margin-left: -45%;
        bottom: 0;
        background-color: #f5253c;
    }




    /*右侧带箭头的选项卡*/
    .tg-tabbar.theme_4{
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom:10px;
        margin-bottom:-10px;
        color:#666;
    }
    .tg-tabbar.theme_4::-webkit-scrollbar {
        height: 0px;
    }
    .tg-tabbar.theme_4 .tg-tabbar-warp{
        background-color:white;
    }
    .tg-tabbar.theme_4 .tg-tabbar-item{
        padding:0.1666666666rem;
        text-align: center;
    }
    .tg-tabbar.theme_4 .tg-tabbar-item i{
        font-size:13px;
    }
    .tg-tabbar.theme_4 .tg-tabbar-item p{
        display:inline-block;
        font-size:13px;
    }
    .tg-tabbar.theme_4 .tg-tabbar-item.active {
        color: #f5253c; }
    .tg-tabbar.theme_4 .tg-tabbar-item.active:before {
        position: absolute;
        display: none;
        content: '';
        width: 90%;
        height: 2px;
        left: 50%;
        margin-left: -45%;
        bottom: 0;
        background-color: #f5253c;
    }
    .tg-tabbar.theme_4 .tg-tabbar_rightCrow:before{
        content: '';
        display: block;
        position: absolute;
        left: -21px;
        top: 0;
        bottom: 0;
        width: 20px;
        background-image: linear-gradient(to right, transparent, white);
        background-image: -webkit-linear-gradient(to right, transparent, white);
    }
    .tg-tabbar.theme_5{
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom:10px;
        margin-bottom:-10px;
        color:#666;
    }
    .tg-tabbar.theme_5::-webkit-scrollbar {
      height: 0px;
    }
    .tg-tabbar.theme_5 .tg-tabbar-warp{
        background-color:white;
        border-bottom:1px solid #e0e0e0;
    }
    .tg-tabbar.theme_5 .tg-tabbar-item{
        padding:0.2666666666rem;
        text-align: center;
    }
    .tg-tabbar.theme_5 .tg-tabbar-item i{
        font-size:13px;
    }
    .tg-tabbar.theme_5 .tg-tabbar-item p{
        display:inline-block;
        font-size:15px;
    }
    .tg-tabbar.theme_5 .tg-tabbar-item.active {
    color: #ff4c48; }
    .tg-tabbar.theme_5 .tg-tabbar-item.active:before {
    position: absolute;
    display: block;
    content: '';
    width: 100%;
    height: 2px;
    left: 0%;
    bottom: 0;
    background-color: #ff4c48;}
    .tg-tabbar.theme_6{
        color: #666;
    }
    .tg-tabbar.theme_6 .tg-tabbar-warp{
        background-color:white;
    }
    .tg-tabbar.theme_6 .tg-tabbar-item{
        padding:0.2666666666rem 0 0.2rem;
        text-align: center;
    }
    .tg-tabbar.theme_6 .tg-tabbar-item i{
        font-size:22px;
    }
    .tg-tabbar.theme_6 .tg-tabbar-item p{
        font-size:10px;
    }
    .tg-tabbar.theme_6 .tg-tabbar-item.active {
        color: #ff4c48;
        border-bottom:2px solid #ff4c48;
    }
    .tg-tabbar.theme_7 .tg-tabbar-item:first-child:after{
        content: none;
    }
    .tg-tabbar.theme_7 .tg-tabbar-item{
        border-bottom:3px solid transparent;
        font-size:16px !important;
    }
    .tg-tabbar.theme_7 .tg-tabbar-item.active{
        border-bottom:3px solid #FF4C48;
        font-size:18px !important;
    }
</style>
<script>
import _ from '_';
import $ from 'jquery';
export default {
	props:{
		data:Array,
        target:{
            type:Object,
            default:{}
        },
        theme:{
            type:Number,
            default:"1"
        },
        mode: {
			type: String
            , default: 'text'
        }
        , sameTabTrigger: {
			type: Boolean
            , default: false
        }
        ,
        col:{
            type:Number,
            default:5
        },
        totalWidth:{
            type:Number,
            default:10
        },
        tabIndex: {
			type: Number
            , default: 0
        }
        , tabIndexName:{
            type:String,
            default:'TGTabIndex'
        }
	},
	computed:{
		showStatus:function(){
			return !!this.data.length
		},
        rsTheme:function(){
            return 'theme_'+this.theme;
        },
        itemWidth:function(){
            return this.totalWidth / this.col +'rem';
        },
        warpWidth:function(){
            return this.data.length * this.totalWidth / this.col +(this.theme==4)+'rem'
        }
	},
    data(){
        var _this=this;
        return {
            activeIndex:(function(){
                if(maple.url().params[_this.tabIndexName]!==undefined){
                    return maple.url().params[_this.tabIndexName]
                }
                else if( _this.tabIndex ){
                	return _this.tabIndex;
                }
                else{
                    return 0
                }
            })()
        }
    },
    ready:function(){
        if(!this.$el.id){
            this.$el.id=_.uniqueId('tgTabbar_');
        }
        this.$dispatch('initTabComponent',this.target,this.activeIndex);
    },
    methods:{
        loadContent(item,index){
            function formatTabBarParams(url){
            	if( url ){
		            var baseParams=maple.url().params;
		            delete baseParams.tgTabBarParams;
		            var baseParamsKey=Object.keys(baseParams);
		            var params=maple.url(url).params;
		            delete params.currentView;
		            delete params.updateView;
		            delete params.tabIndex;
		            _.forEach(params,function(value,key){
			            if(_.includes(baseParamsKey,key)){
				            delete params[key]
			            }
		            })
		            return params;
                }
                else{
            		return {};
                }
            }

            if( !this.sameTabTrigger && this.activeIndex==index){
                return
            }
            var currentIndex=this.activeIndex;
            this.activeIndex=index;
            let np={tgTabBarParams:JSON.stringify(formatTabBarParams(item.httpUrl))};
            np[this.tabIndexName]=index;
            !maple.device.weixin && maple.url().replace(np);
            this.$dispatch('loadTabComponent',item,this.target,index,currentIndex);
        },
        scrollNext(){
            var dom=$(this.$el);
            var left=dom.scrollLeft();
            var dis=dom.find('.tg-tabbar-warp').width()/(this.data.length||1)
            dom.animate({'scrollLeft':left+dis})
        }
    }
    , watch: {
        data: function(newVal){
            if( !newVal || !newVal.length ){
                this.activeIndex = 0;
            }
        }
    }
}
</script>